import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { ENSGridResizeType, INSGridConfig } from '@norfolk-southern/accessns-components';
import { ColDef, FirstDataRenderedEvent, GridOptions } from 'ag-grid-community';

import { NSCommonConstants } from '@ruby/configs/common.constants';
import { NSRateResultsConstant } from '@ruby/configs/rate-inquiry.constants';
import { IRateDetail } from '@ruby/modules/rate-inquiry/models/rate-inquiry.interface';

@Component({
  selector: 'ng-rate-results',
  templateUrl: './rate-results.component.html',
  styleUrls: ['./rate-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RateResultsComponent implements OnDestroy {
  @Input() data!: Array<IRateDetail>;
  @Input() loading!: boolean;
  @Input() displayResults!: boolean;
  @Output() clearAllRateData = new EventEmitter();
  resizeType = ENSGridResizeType.AUTOSIZECOLUMNS;
  columnDefs: Array<ColDef> = NSRateResultsConstant.columnsDef;
  options: GridOptions = {
    rowHeight: 75,
    suppressColumnVirtualisation: true,
    overlayNoRowsTemplate: NSCommonConstants.noResultsFoundMessage,
    groupUseEntireRow: true
  };
  config: INSGridConfig = {
    hide: {
      download: {
        pdf: true,
        xls: true,
        csv: true
      }
    }
  };

  constructor() {}

  ngOnDestroy(): void {
    this.clearAllRateData.emit();
  }

  /**
   * Grid Data Rendered
   *
   * @summary Set all columns to auto size based off its content when grid data is first rendered
   * @param $event: FirstDataRenderedEvent
   * @returns void
   */
  gridDataRendered($event: FirstDataRenderedEvent): void {
    const allColumnIds: Array<string> = [];
    $event.columnApi.getAllColumns()!.forEach(column => {
      allColumnIds.push(column.getColId());
    });
    $event.columnApi.autoSizeColumns(allColumnIds, false);
  }
}
